import { initI18n as initI18nConfig } from '@wix/wix-i18n-config';
import { getPathToMessages } from '@wix/app-installer/internal-use';
import { INSTALLER_TOPOLOGY_API_URL } from './apis';
let i18n;
export const initI18n = async _ref => {
  let {
    errors,
    topology,
    httpClient,
    messagesPromise
  } = _ref;
  if (!i18n) {
    try {
      const {
        messages,
        locale
      } = await loadI18nConfig({
        httpClient,
        messagesPromise,
        topology
      });
      i18n = initI18nConfig({
        locale: locale || 'en',
        messages
      });
    } catch (error) {
      errors.push(error);
    }
  }
};
const loadI18nConfig = async _ref2 => {
  let {
    topology,
    httpClient,
    messagesPromise
  } = _ref2;
  let messages;
  let locale;
  if (messagesPromise && topology != null && topology.languageCode) {
    messages = await messagesPromise;
    locale = topology.languageCode;
    return {
      messages,
      locale
    };
  }
  const {
    data: {
      topology: {
        translations
      },
      languageCode
    }
  } = await httpClient.get(INSTALLER_TOPOLOGY_API_URL);
  locale = languageCode;
  if (!messagesPromise) {
    const {
      data
    } = await httpClient.get(getPathToMessages(translations, locale));
    messages = data;
  } else {
    messages = await messagesPromise;
  }
  return {
    messages,
    locale
  };
};
export const getI18n = () => {
  if (!i18n) {
    throw new Error('App installer i18n is not initialized.');
  }
  return i18n;
};
//# sourceMappingURL=i18n.js.map